module.exports = __webpack_public_path__ + "static/media/2021-isuzu-dmax.447ac785.webp";